import { downloadsData } from '@/mocks/pages';

function DownloadsPage() {
  return (
    <>
      <section className="relative w-full h-[330px] md:h-[380px] overflow-hidden">
        <div className="absolute inset-0 bg-primary-950/85 z-0" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/40 z-[1]" />
        <div className="absolute inset-0 z-[1]">
          <img
            src="/images/banner-bg.jpg"
            alt="资源下载"
            className="w-full h-full object-cover object-top opacity-35"
          />
        </div>
        <div className="relative z-10 h-full flex flex-col items-center justify-center px-4 md:px-8 text-center">
          <div className="w-full max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-5xl font-extrabold text-white tracking-tight leading-tight mb-4">{downloadsData.heroTitle}</h1>
            <p className="text-lg md:text-xl text-white/80 font-light mb-3">{downloadsData.heroSubtitle}</p>
            <p className="text-sm md:text-base text-white/60 max-w-2xl mx-auto">{downloadsData.heroDesc}</p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-6xl mx-auto">
          <div className="space-y-10 md:space-y-14">
            {downloadsData.categories.map((cat, idx) => (
              <div key={idx}>
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500"><i className={`${cat.icon} text-lg`}></i></div>
                  <h2 className="text-xl md:text-2xl font-bold text-foreground-900">{cat.title}</h2>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {cat.items.map((item, iidx) => (
                    <a key={iidx} href={item.url} target="_blank" rel="noopener noreferrer" className="block bg-white rounded-xl border border-background-200 p-5 hover:border-primary-200 transition-all duration-300 cursor-pointer">
                      <div className="flex items-start justify-between mb-2">
                        <span className="text-xs font-semibold text-primary-600 bg-primary-50 px-2.5 py-1 rounded-md whitespace-nowrap">{item.type}</span>
                        <span className="text-xs text-foreground-400 whitespace-nowrap">{item.size}</span>
                      </div>
                      <h4 className="text-sm font-bold text-foreground-900 mb-1.5">{item.name}</h4>
                      <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 px-4 md:px-8 lg:px-12 bg-primary-500">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">找不到需要的资源？</h2>
          <p className="text-white/75 text-sm md:text-base mb-8">联系技术支持团队，我们将为您发送所需资料</p>
          <a href="/contact" className="inline-flex items-center px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"><i className="ri-mail-send-line mr-2"></i>联系技术支持</a>
        </div>
      </section>
    </>
  );
}

export default DownloadsPage;